import $ from 'jquery';
import CartJS from 'shopify-cartjs';

document.addEventListener('alpine:init', () => {

    const debounce = (func, wait) => {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };

    Alpine.store('cart', {
        items: [],
        subTotal: 0,
        itemsCount: 0,
        isOpen: false,
        cartError: '',
        price(price) {
            if (!price) return;
    
            const newPrice = price / 100;
            const formattedPrice = newPrice.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
    
            return formattedPrice;
        },
        sortByPrice(items) {
            if (!items.length) return [];
            return items.sort((a, b) => a.price - b.price);
        },
        addToCart(variantId, quantity, sellingPlanId, properties) {
            const activeQTY = quantity ? quantity : 1;
            
            CartJS.addItem(variantId, activeQTY, {
                "selling_plan": sellingPlanId,
                ...properties
            },
            {
                "success": (data, textStatus, jqXHR) =>{
                    this.isOpen = true;
                    console.log(data);
                },
                "error": (jqXHR, textStatus, errorThrown) => {
                    this.cartError = jqXHR.responseJSON.description;
                    console.log(jqXHR);
                }
            });
        },
        updateCart(cart) {
            if (!cart) {
                cart = CartJS.cart;
            }
            this.items = cart.items;
            this.subTotal = cart.total_price;
            this.itemsCount = cart.item_count;
        },
        currency() {
            return this.getCurrencySymbol(CartJS.cart.currency);
        },

        decodeHtmlEntities(str) {
            const entities = {
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": "\"",
                "&#39;": "'"
            };
            if (!str) return '';
            return str.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, match => entities[match]);
        },

        getProductName(title) {
            const titleParts = title ?  title.split('|') :  false;
            const formattedTitle = titleParts ? this.decodeHtmlEntities(titleParts[0]) + ' | ' + this.decodeHtmlEntities(titleParts[1]) : '';
            return formattedTitle;
        },

        getSubtotal() {
            const subtotal = `${this.currency()}${CartJS.cart.total_price / 100}`;
            return subtotal;
        },
    
        getCurrencySymbol(currency) {
            const symbols = {
                'USD': '$',
                'EUR': '€',
                'GBP': '£',
                'RUB': '₽',
                'JPY': '¥',
                'CNY': '¥',
            };
            return symbols[currency] || currency;
        },

        updateItem: debounce((itemId, quantity) => {
            CartJS.updateItemById(itemId, quantity, {}, {
                "success": (cart, textStatus, jqXHR) => {
                    Alpine.store('cart').updateCart(cart);
                },
                "error": (jqXHR, textStatus, errorThrown) => {
                    console.log('error');
                    Alpine.store('cart').cartError = jqXHR.responseJSON.description;
                }
            }); 
        }, 500),

        removeItem(itemId) {
            CartJS.removeItemById(itemId);
        },

        init() {
            CartJS.init(window.CartObject, {
                "dataAPI": false,
                "requestBodyClass": "loading"
            });

            if (CartJS.cart) {
                this.items = CartJS.cart.items;
                this.itemsCount = CartJS.cart.item_count;
                this.subTotal = CartJS.cart.total_price;

                console.log(this.items);
            }
        },
    });

    jQuery(document).on('cart.requestComplete', function(event, cart) {
        Alpine.store('cart').updateCart(cart);
    });
});
